// extracted by mini-css-extract-plugin
export var button = "Banner-module--button--EiXd8";
export var greenTheme = "Banner-module--greenTheme--IE-xC";
export var roseTheme = "Banner-module--roseTheme--lZMpY";
export var text = "Banner-module--text--VZMCc";
export var title = "Banner-module--title--s8W8i";
export var wrapper = "Banner-module--wrapper--vqo8V";